// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2MtEq","error":"Textarea_error__dm3Lr","readonly":"Textarea_readonly__1_C--","disabled":"Textarea_disabled__3I8Zl"};